import { render, staticRenderFns } from "./MessageOverview.vue?vue&type=template&id=299be061&"
import script from "./MessageOverview.vue?vue&type=script&lang=js&"
export * from "./MessageOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports